import classNames from 'classnames'
import { t } from 'i18next'
import { SetStateAction, useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getArtifacts } from '../../../api/artifactsapi'
import { getCodeDescription } from '../../../api/codedescapi'
import { postPolicy } from '../../../api/policypostapi'
import ChildPlanFormDataContext from '../../../contexts/ChildPlanFormDataContext'
import ParentFormDataContext from '../../../contexts/ParentFormDataContext'
import PaymentFormDataContext from '../../../contexts/PaymentFormDataContext'
import { PaymentFormDataObject } from '../../../contexts/contextDataObjects/PaymentFormDataObject'
import { IPolicyResponse } from '../../../model/IPolicyReponse'
import { IPolicyRequest } from '../../../model/IPolicyRequest'
import { getMonerisCSS } from '../../../utils/monerisHelper'
import Button from '../../button/Button'
import ButtonSelect, { IButtonSelectItem } from '../../buttonSelect/ButtonSelect'
import DropDownList, { ddlListItem } from '../../dropDownList/DropDownList'
import InputBox from '../../inputBox/InputBox'
import CircleSpinner from '../../spinners/circleSpinner/CircleSpinner'
export interface IPaymentInformation {
    className?: string
    setShowConfirmation: React.Dispatch<SetStateAction<boolean>>
    setShowReceipt: React.Dispatch<SetStateAction<boolean>>
    setPolicyResponse: React.Dispatch<SetStateAction<IPolicyResponse>>

}

const PaymentInformation: React.FC<IPaymentInformation> = ({
    className,
    setShowConfirmation,
    setShowReceipt,
    setPolicyResponse
}) => {
    const [listItems, setListItems] = useState<ddlListItem[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [monerisIframeSrc, setMonerisIframeSrc] = useState<string>('')
    const [isMail, setIsMail] = useState<string>('no')
    const [disableBuyNow, setDisableBuyNow] = useState<boolean>(true)

    const { paymentFormData, setPaymentFormData } = useContext(
        PaymentFormDataContext
    )
    const { childPlanFormData, } = useContext(
        ChildPlanFormDataContext
    )
    const { parentFormData } = useContext(
        ParentFormDataContext
    )

    const mailOptions: IButtonSelectItem[] = [
        {
            mainText: t('Yes'),
            secondaryText: '',
            index: 0,
            value: 'yes',
        },
        {
            mainText: t('No'),
            secondaryText: '',
            index: 1,
            value: 'no',
        },
    ]

    useEffect(() => {
        getCreditCards()
        getCCArtifacts()
    }, [])

    useEffect(() => {
        if (paymentFormData.Artifacts.Url.length > 0) {
            const src = decodeURIComponent(paymentFormData.Artifacts?.Url.toString() as string) + getMonerisCSS()
            setMonerisIframeSrc(src)
        }
    }, [paymentFormData.Artifacts.Url])

    async function getCreditCards() {
        try {
            const creditCards = await getCodeDescription('crditcrdtp', 0)
            const options: ddlListItem[] = creditCards.map((creditCards) => ({
                name: creditCards.description,
                id: creditCards.codeDescId,
                code: creditCards.code
            }))
            setListItems(options)
        } catch (error) {
            toast.error(`${t('errorCouldNotLoadCreditCards')}`)
        }
    }

    async function getCCArtifacts() {
        try {
            const artifacts = await getArtifacts('sai', 0, true)
            setPaymentFormData({
                ...paymentFormData,
                ['Artifacts']: artifacts.values,
            })
        } catch (error) {
            toast.error('Error - Could not Artifacts')
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setPaymentFormData({ ...paymentFormData, [name]: value })
    }
    const handleDDLChange = (name: string, value: ddlListItem) => {
        setPaymentFormData({ ...paymentFormData, [name]: value })
    }

    var respMsg = async function (e: any) {
        var respData = eval('(' + e.data + ')')
        try {
            setPaymentFormData({
                ...paymentFormData,
                ['HfDataKey']: respData.dataKey,
                ['HfResponseCode']: respData.responseCode,
                ['HfErrorMessage']: respData.errorMessage,
            })

            window.removeEventListener('message', respMsg, false)

            //todo display error and if all good then make api call to create policy
            let valid = false;
            if (paymentFormData.ExpMo === '' || paymentFormData.ExpYr === '' || paymentFormData.CCType.code === '' || paymentFormData.Payor === '') {
                toast.warn(`${t('errorProvideAllData')}`)
                return;
            }
            switch (respData.responseCode[0]) {
                case '001':
                    valid = true
                    break;
                case '940':
                    toast.error(`${t('InvalidProfileToken')}`)
                    break;
                case '941':
                    toast.error(`${t('Error generating token')}`)
                    break;
                case '942':
                    toast.error(`${t('InvalidProfileID')}`)
                    break;
                case '943':
                    toast.error(`${t('CarddataIsInvalid')}`)
                    break;
                case '944':
                    toast.error(`${t('InvalidExpirationDate')}`)
                    break;
                case '945':
                    toast.error(`${t('InvalidCVD')}`)
                    break;
                default:
                    toast.error(`${t('inValidDataForPayment')}`)
                    break;
            }
            if (valid) {
                setLoading(true);
                const data = createPolicyRequestData(respData);
                //todo nik need to move this to API service
                const res: IPolicyResponse = await postPolicy(data);

                setShowReceipt(true);
                setPolicyResponse(res);
                toast.success(`${t('policycreationsuccess')}`);
            }
        } catch (err: any) {
            console.log('err', err);
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    }

    function doMonerisSubmit(event: any) {
        if (window.addEventListener) {
            window.addEventListener('message', respMsg, false)
        }
        // else {
        //     if (window.attachEvent) {
        //         window.attachEvent("onmessage", respMsg);
        //     }
        // }
        // post to Moneris
        var monFrameRef = (document?.getElementById('monerisFrame1') as any)
            ?.contentWindow
        monFrameRef.postMessage('tokenize', paymentFormData.Artifacts?.Url)
    }

    const createPolicyRequestData = (respData: any) => {
        const data: IPolicyRequest = {
            "contactAddress": {
                "address1": parentFormData.Address.trim(),
                "address2": '',
                "city": parentFormData.City.trim(),
                "provstate": parentFormData.Province.id,
                "postalcode": parentFormData.PostalCode.toUpperCase().trim()
            },
            "insureds": [],
            "language": parentFormData.Language,
            "schoolBoardId": parentFormData.SchoolBoard.id,
            "emailAddress": parentFormData.Email.trim(),
            "externalRef": parentFormData.ExternalRef ? parentFormData.ExternalRef.trim() : "",
            "postalCode": parentFormData.PostalCode.trim(),
            "phone": parentFormData.PhoneNumber.trim(),
            "isEmail": true,
            "isMail": isMail.toLowerCase() === 'yes' ? true : false,
            "parentLast": parentFormData.LastName.trim(),
            "parentFirst": parentFormData.FirstName.trim(),
            "provstate": parentFormData.Province.id,
            "cardType": paymentFormData.CCType.code,
            "cardMM": paymentFormData.ExpMo,
            "cardYY": paymentFormData.ExpYr,
            "cardName": paymentFormData.CCType.name,
            "payor": paymentFormData.Payor,
            "hfResponseCode": respData.responseCode[0],
            "hfDataKey": respData.dataKey,
            "hfErrorMessage": respData.errorMessage,
            "isRenewal": parentFormData.AutoEnroll.Renew.toLowerCase() === 'yes' ? true : false,
            "effectivedate": parentFormData.StartDate ? parentFormData.StartDate : new Date()
        }
        childPlanFormData.forEach((i) => {
            data.insureds.push({
                "planCode": i.Plan.PlanCode,
                "organizationSchoolId": i.School.id,
                "organizationSchoolName": i.School.name,
                "firstname": i.FirstName.trim(),
                "dob": i.Dob,
                "lastname": i.LastName.trim()
            })
        });

        return data
    }

    //todo move to constructor
    // var respMsg = function (e:any) {
    //     console.log(e,'data')
    //     var respData = eval("(" + e.data + ")");
    //     console.log(respData,'resData')
    //     // save the results in hidden fields

    //     // submit the parent form
    //     var postbutton = document.getElementById('<%=GetParentPostButton()%>');
    //     // postbutton.click();
    // }

    // const handleSelectMailOption = (option: IButtonSelectItem) => {
    //     setIsMail(option.value)
    // }

    const handleButtonSelectChange = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        primary: string,
        secondary: string,
        i: number
    ) => {
        const { value } = e.currentTarget
        setIsMail(value)
    }

    useEffect(() => {
        if (paymentFormData.ExpMo === '' || paymentFormData.ExpYr === '' || paymentFormData.CCType.code === '' || paymentFormData.Payor === '') {
            setDisableBuyNow(true)
        }
        else if (paymentFormData.ExpMo !== '' && paymentFormData.ExpYr !== '' && paymentFormData.CCType.code !== '' && parentFormData.Payor !== '') {
            setDisableBuyNow(false)
        }
    }, [paymentFormData])

    const initialPaymentData = PaymentFormDataObject
    return (
        <div className='flex justify-center pt-7'>
            <div className={classNames(className)}>
                <div className="h-auto flex flex-col justify-center items-center pt-5 bg-white lg:w-[55rem] md:w-[31rem] w-[20rem] shadow-md py-6">
                    <h1 className="text-center font-bold lg:text-xl text-lg">
                        {t('paymentInfo')}
                    </h1>
                    <div className='grid lg:grid-cols-2 grid-cols-1 lg:space-y-0 space-y-4 lg:items-baseline place-items-center'>
                        <DropDownList
                            className="pt-5"
                            width="w-[14rem]"
                            minWidth='min-w-[5rem]'
                            height="h-12"
                            label={t('creditCardType') || ''}
                            list={listItems}
                            inputID="ccTypeInput"
                            selectedItem={paymentFormData.CCType}
                            name={'CCType'}
                            required={true}
                            onChange={handleDDLChange}
                        />
                        <InputBox
                            type="text"
                            inputID="ccPayor"
                            label={t('cardHolderName') || ""}
                            width="w-[14rem] border-[1.5px] border-gray-400 "
                            minWidth='w-[14rem]'
                            height="h-[3.15rem]"
                            shadow="shadow-md"
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => handleChange(e)}
                            value={paymentFormData.Payor}
                            name={'Payor'}
                        />
                        <div className='ml-2.5'>
                            <label className="font-sans block text-md font-medium text-gray-700 w-32 ml-[0.65rem]">
                                {t('cardNumber')}
                            </label>
                            <iframe
                                id="monerisFrame1"
                                src={monerisIframeSrc}
                                width="255px"
                                height="60px"
                                title="myFrame"
                            ></iframe>
                        </div>
                        <div className="lg:pt-5 items-start">
                            <label className="font-sans block text-md font-medium text-gray-700 w-32 ">
                                {t('expiryDate')}
                            </label>
                            <div className="flex flex-row space-x-4 pb-3">
                                <InputBox
                                    type="text"
                                    inputID="ccExpMo"
                                    width="w-20 border-[1.5px] border-gray-400 "
                                    minWidth='w-[6.5rem]'
                                    height="h-[3.15rem]"
                                    shadow="shadow-md"
                                    bottomLabel="MM"
                                    onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                    ) => handleChange(e)}
                                    value={paymentFormData.ExpMo}
                                    name={'ExpMo'}
                                    maxLength={2}
                                />
                                <InputBox
                                    type="text"
                                    inputID="ccExpYr"
                                    width="w-20 border-[1.5px] border-gray-400 "
                                    minWidth='w-[6.5rem]'
                                    height="h-[3.15rem]"
                                    shadow="shadow-md"
                                    bottomLabel={t('yy') || ''}
                                    onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                    ) => handleChange(e)}
                                    value={paymentFormData.ExpYr}
                                    name={'ExpYr'}
                                    maxLength={2}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="py-5 bg-[#94bddb] h-auto flex flex-col items-center shadow-md lg:w-[45rem] md:w-[28rem] w-[20rem] lg:px-0 px-8"> */}
                    <div className="py-5 h-auto flex flex-col items-center  lg:w-[45rem] md:w-[28rem] w-[20rem] lg:px-0 px-8">
                        <h1 className="text-center font-bold text-md">
                            {t('finalConfirmation')}
                        </h1>
                        <p className="w-[22rem] pt-2 text-black-600 text-sm text-center">
                            {t('howToReceiveInsuranceText')}
                        </p>

                        <div className="py-2 px-3 flex flex-col lg:flex-row lg:space-x-4 justify-center">
                            <ButtonSelect
                                options={mailOptions}
                                className="font-bold hover:bg-[#0082ca]"
                                selectColor="bg-[#0082ca] text-black"
                                baseColor="bg-white text-black"
                                textColor="text-black"
                                size="md:h-[4rem] h-[3.5rem] md:w-[8rem] w-[7rem]"
                                onChange={handleButtonSelectChange}
                                selected={isMail}
                            />
                        </div>
                        <p className="lg:w-[22rem] w-[15rem] pt-2 text-black-600 text-sm text-center">
                            {t('reviewInfoText')}
                        </p>
                    </div>
                    <div className="py-3 h-auto flex flex-col lg:flex-row lg:space-x-4 items-center">
                        {loading ? <CircleSpinner className='md:w-72 w-56 flex justify-center items-center lg:pt-4 pt-0' size='50px' /> : <Button
                            className={classNames("hover:bg-[#49a4d7] bg-[#0082ca] md:w-72 w-56 h-12  font-bold mt-5 shadow-md border-[1.5px] border-gray-400 text-black")}
                            text="payment"
                            handleClick={(event) => {
                                doMonerisSubmit(event)
                            }}
                            textColor="text-black"
                            textSize="md:text-xl text-lg"
                        />
                        }
                        <Button
                            className="bg-white md:w-72 w-56 h-12 hover:bg-gray-200 font-bold mt-5 shadow-md border-[1.5px] border-gray-400"
                            text="goBack"
                            handleClick={() => {
                                setShowConfirmation(false)
                                setPaymentFormData(initialPaymentData)
                            }}
                            disabled={loading ? true : false}
                            textColor="text-black"
                            textSize="md:text-xl text-lg"
                        />

                    </div>
                </div>
            </div >
        </div >
    )
}

export default PaymentInformation;
